import { FormlyFieldConfig } from '@ngx-formly/core';
import { LAYOUT_ROOT_ID, layoutNodeIdOf, type FormOverlayFieldNode } from '@phoenix/common';

/**
 * **Layout node id** of a live Formly field, walking parents and skipping the synthetic root.
 */
export function layoutNodeIdFromFormlyField(field: FormlyFieldConfig): string {
    const chain: FormlyFieldConfig[] = [];
    let current: FormlyFieldConfig | undefined = field;
    while (current?.parent) {
        chain.unshift(current);
        current = current.parent;
    }
    let parentId = LAYOUT_ROOT_ID;
    let id = LAYOUT_ROOT_ID;
    for (const node of chain) {
        id = layoutNodeIdOf(node as FormOverlayFieldNode, parentId);
        parentId = id;
    }
    return id;
}
